export default "__VITE_ASSET__vWF84YI5__"